import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description BellNotification icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { BellNotification } from '@sravni/design-system-icons'
 *
 * <BellNotification />
 * ```
 */
var BellNotification = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "BellNotification", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M8.09 15.287v.304a1.91 1.91 0 0 0 3.82-.001v-.304M11.527 4.793v-.766a1.527 1.527 0 1 0-3.055 0v.766", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M5.47 8.49a3.776 3.776 0 0 1 3.775-3.776h1.51a3.776 3.776 0 0 1 3.777 3.776v2.33c0 .442.175.867.488 1.18l.534.533c.313.313.488.737.488 1.179 0 .87-.705 1.575-1.575 1.575H5.533c-.87 0-1.575-.705-1.575-1.575 0-.442.176-.866.489-1.179L4.98 12c.312-.312.488-.737.488-1.178V8.49Z", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))); });

export { BellNotification };
//# sourceMappingURL=BellNotification.js.map
